"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.auditLogQuerySchema = void 0;
const zod_1 = require("zod");
/**
 * The audit log, as the staff app reads it — SPEC §3 (`audit.view`).
 *
 * Every sensitive mutation already writes an `AuditLog` row (bill edits and
 * deletes, discounts, refunds, voids, privilege changes, secret reveals,
 * hot-key unlocks, settings changes). Until 2026-09-24 nothing could READ
 * them; `audit.view` gated no route. This is that reading: a filtered,
 * newest-first, cursor-paged list.
 *
 * READ-ONLY BY DESIGN. There is no edit and no delete, for anyone, owners
 * included — a log its subject can prune is not a control.
 *
 * Route: `GET /audit-log` (`audit.view`), query {@link auditLogQuerySchema},
 * answer {@link AuditLogPageDto}.
 */
/** An ISO date-time from a picker; resolved server-side. Same rule as the box-reset list. */
const isoDateTime = zod_1.z
    .string()
    .trim()
    .refine((value) => !Number.isNaN(Date.parse(value)), 'Expected an ISO date-time.');
/**
 * `GET /audit-log` filters. All optional; `limit` defaults to 50.
 *
 *  - `from` / `to` — ISO instants bounding `createdAt` (NOT business dates:
 *    an audit row is a moment, and "what happened between 23:40 and 00:10"
 *    is the question an investigation asks).
 *  - `action` — a PREFIX: `bill.` matches `bill.edit` and `bill.delete`.
 *  - `q` — free text over action, entity type/id, actor label and employee
 *    name. Not over the before/after JSON: that is unindexed and unbounded.
 *  - `cursor` — opaque; pass back the previous page's `nextCursor` unchanged.
 */
exports.auditLogQuerySchema = zod_1.z.object({
    from: isoDateTime.optional(),
    to: isoDateTime.optional(),
    action: zod_1.z.string().trim().min(1).max(80).optional(),
    employeeId: zod_1.z.string().trim().min(1).max(64).optional(),
    entityType: zod_1.z.string().trim().min(1).max(60).optional(),
    entityId: zod_1.z.string().trim().min(1).max(64).optional(),
    q: zod_1.z.string().trim().min(1).max(120).optional(),
    cursor: zod_1.z.string().trim().min(1).max(200).optional(),
    limit: zod_1.z.coerce.number().int().min(1).max(200).default(50),
});
//# sourceMappingURL=audit.js.map